var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
export var LEVEL;
(function (LEVEL) {
    LEVEL[LEVEL["OFF"] = 0] = "OFF";
    LEVEL[LEVEL["ERROR"] = 1] = "ERROR";
    LEVEL[LEVEL["WARNING"] = 2] = "WARNING";
    LEVEL[LEVEL["INFO"] = 3] = "INFO";
    LEVEL[LEVEL["DEBUG"] = 4] = "DEBUG";
})(LEVEL || (LEVEL = {}));
export var FACILITY;
(function (FACILITY) {
    FACILITY[FACILITY["NONE"] = 0] = "NONE";
    FACILITY["FRAME_CACHE"] = "FRAMECACHE";
    FACILITY["FRAME_BUILDER"] = "FRAMEBUILDER";
    FACILITY["PLAYBACK"] = "PLAYBACK";
    FACILITY["BODY"] = "BODY";
    FACILITY["GENERAL"] = "SHAREDJS";
    FACILITY["ALIGNMENT"] = "ALIGNMENT";
    FACILITY["ANALYTICS_ENGINE"] = "ANALYTICS_ENGINE";
    FACILITY["TEST"] = "TEST";
})(FACILITY || (FACILITY = {}));
var Log = (function () {
    function Log() {
        this.levels = {};
        this.levels[FACILITY.FRAME_CACHE] = LEVEL.INFO;
        this.levels[FACILITY.BODY] = LEVEL.ERROR;
        this.levels[FACILITY.ALIGNMENT] = LEVEL.ERROR;
        this.levels[FACILITY.PLAYBACK] = LEVEL.ERROR;
        this.levels[FACILITY.ANALYTICS_ENGINE] = LEVEL.ERROR;
        this.levels[FACILITY.FRAME_BUILDER] = LEVEL.ERROR;
    }
    Log.prototype.set = function (facility, level) {
        this.levels[facility] = level;
    };
    Log.prototype.log = function (facility, level) {
        var args = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            args[_i - 2] = arguments[_i];
        }
        if (this.levels[facility] < level) {
            return;
        }
        console.log.apply(this, __spreadArray([facility + ":" + LEVEL[level]], args.slice(), true));
    };
    Log.prototype.debug = function (facility) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.log.apply(this, __spreadArray([facility, LEVEL.DEBUG], args, false));
    };
    Log.prototype.info = function (facility) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.log.apply(this, __spreadArray([facility, LEVEL.INFO], args, false));
    };
    Log.prototype.warn = function (facility) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.log.apply(this, __spreadArray([facility, LEVEL.WARNING], args, false));
    };
    Log.prototype.error = function (facility) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        this.log.apply(this, __spreadArray([facility, LEVEL.ERROR], args, false));
    };
    return Log;
}());
export var log = new Log();
export function format(v, points) {
    if (points === void 0) { points = 3; }
    if (!v) {
        return 'undefined';
    }
    if (Array.isArray(v)) {
        var reducer = function (prev, cur) {
            if (Array.isArray(cur)) {
                return prev + "\n[" + format(cur, points) + "]";
            }
            if (prev === '') {
                return cur.toFixed(points);
            }
            return prev + ", " + cur.toFixed(points);
        };
        return v.reduce(reducer, '');
    }
    if (typeof v === 'number') {
        return "" + v.toFixed(points);
    }
    if (typeof v === 'object' && v.toVector) {
        return format(v.toVector(), points);
    }
    if (typeof v === 'object' && v.toArray) {
        return format(v.toArray(), points);
    }
    console.log('format failed on ', typeof v);
    return v;
}
//# sourceMappingURL=log.js.map